<template>
  <div>
    <dHeader />
    <div class="web-main web-support-main">
      <!-- <transition name="fade"> -->
      <router-view :key="$route.fullPath" />
       <!-- </transition> -->
    </div>
    <dFooter />
  </div>
</template>
<script>
import(
  `@/assets/css/${
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? 'mobile'
      : 'pc'
  }/index.scss`
)
import dHeader from '@/components/support-layouts/d-header'
import dFooter from '@/components/layouts/d-footer'
import dLogo from '@/components/layouts/d-logo'
export default {
  name: 'web',
  data() {
    return {}
  },
  components: {
    dHeader,
    dFooter,
    dLogo,
  },
  computed: {},
}
</script>
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: 
  opacity 0.5s;
}
.fade-enter,.fade-leave-to{
  opacity: 0;
}
</style>
